import { render, staticRenderFns } from "./Lottery.vue?vue&type=template&id=6af80b58&scoped=true"
import script from "./Lottery.vue?vue&type=script&lang=js"
export * from "./Lottery.vue?vue&type=script&lang=js"
import style0 from "./Lottery.vue?vue&type=style&index=0&id=6af80b58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af80b58",
  null
  
)

export default component.exports